import React, { useState } from 'react';
import { getLastActiveDevice } from '#component/shipment/overview/helper';
import { getYoungestMetrics } from '#component/device/helper';
import { DevicesDialog } from '#component/dashboard/mobile-view/devices-dialog';
import { getLastCompletedStepIndex, getShipmentStatus } from '#component/shipment/helper';
import { dateFormatter } from '#component/shipment/dashboard/cards-view/mobile-card-view';
import StepProgressBar from '#component/shipment/dashboard/cards-view/step-progress-bar';
import { getAddressString } from '#component/shipment/overview/shipment-timeline/timeline-step';
import { ShipmentInfoCard } from './info';
import { EventsListDialog } from './events-list-dialog';
import EventsCard from './events-card';
import MapCard from './map-card';
import MeasurementCard from './measurements-card';
import DialogWithMeasurements from './dialog-measurements';
import { CardWrapper, ProgressBarContainer } from './styles';

function MobileView(props) {
  const {
    eventsLoadingStatus,
    tabProps,
    shipment,
    history,
    identifiers,
    events,
    selectedDevices,
    account,
    meta,
    locationsLoading,
    clickedDevices,
    setClickedDevices,
    clickedEvents,
    setClickedEvents
  } = props;

  const [open, setOpen] = useState(false);

  const EVENTS_TAB = 100;
  const TIMELINE_TAB = 110;
  const INFO_TAB = 120;

  const device = locationsLoading ? {} : getLastActiveDevice(selectedDevices, account, meta);
  const lastCompletedStepIndex = getLastCompletedStepIndex(shipment?.delivery ?? []);
  const destinationCountry = shipment?.delivery?.length > 0 ?
    getAddressString(shipment.delivery[shipment.delivery.length - 1]?.address) : undefined;
  const originCountry = shipment?.delivery?.length > 0 ?
    getAddressString(shipment.delivery[0]?.address) : undefined;
  // Card summaries show the last value from the already-loaded `lastMetric.youngest`, so we
  // don't need to fetch the full per-metric arrays just to render the card grid.
  const activeDeviceData = selectedDevices.find(d => d.id === device.id);
  const presentMeasurements =
    getYoungestMetrics(activeDeviceData?.lastMetric?.youngest, account, identifiers);

  const handleClickOpen = tabNum => {
    setOpen(!open);
    history.replace(tabProps(tabNum).to);
  };

  const handleClose = () => {
    setOpen(!open);
  };

  const timelineComponent = shipment?.delivery?.length > 0 ? (
    <ProgressBarContainer
      type="button"
      aria-label="Open Timeline"
      onClick={() => handleClickOpen(TIMELINE_TAB)}
    >
      <StepProgressBar
        completedSteps={lastCompletedStepIndex + 1}
        allSteps={shipment.delivery.length}
        startDate={dateFormatter(shipment.delivery[0].date, account)}
        endDate={
          shipment.delivery.length > 1 ?
            dateFormatter(shipment.delivery[shipment.delivery.length - 1].date, account) :
            undefined
        }
        origin={originCountry}
        destination={destinationCountry}
        StepbackgroundColor="#EEE"
        status={getShipmentStatus(shipment).code * 100}
      />
    </ProgressBarContainer>
  ) : null;

  return (
    <>
      {timelineComponent}
      <CardWrapper>
        <ShipmentInfoCard
          handleOpen={() => handleClickOpen(INFO_TAB)}
        />
        <EventsCard
          handleOpen={() => handleClickOpen(EVENTS_TAB)}
          events={events}
          loading={eventsLoadingStatus}
        />
        {identifiers.map((identifier, index) => (
          <MeasurementCard
            identifier={identifier}
            key={identifier}
            index={index}
            handleOpen={() => handleClickOpen(index)}
            presentMeasurements={presentMeasurements}
            loading={locationsLoading}
          />
        ))}
        <MapCard
          handleClickOpen={handleClickOpen}
          {...props}
        />
        <DialogWithMeasurements handleClose={handleClose} open={open} {...props} />
        <DevicesDialog
          open={Boolean(clickedDevices.length)}
          isMobile={true}
          handleClose={setClickedDevices}
          clickedDevices={clickedDevices}
          loading={false}
          {...props}
        />
        <EventsListDialog
          open={Boolean(clickedEvents.length)}
          isMobile={true}
          handleClose={setClickedEvents}
          loading={false}
          {...props}
        />
      </CardWrapper>
    </>
  );
}

export default MobileView;
